import {useSelectedDocContext} from '../../../../search-hooks';
import React from 'react';
import {AttributesList} from './attributes-list/attributesList';

export const BaseDataRow = (): React.JSX.Element | null => {
    const doc = useSelectedDocContext();
    if (!doc) {
        return null;
    }

    return (
        <div className={'document-infos'}>
            <AttributesList attributes={['id', 'language', 'title']}/>
        </div>
    );
};
